import axios from 'axios';
import path from '../../path';

export const nearestDoctorListingApi = (zipcode,country_of_residence_,Enter_firstname,Enter_lastname,age,age_category) => {
    return axios.get(`${path}/v1/lead/nearest-doctors/${zipcode}/${country_of_residence_}/${Enter_firstname}/${Enter_lastname}/${age}/${age_category}`);
};

export const getPatientInfo = (id, headers) => {
    return axios.get(`${path}/v1/lead/get-patient-info/${id}`, headers);
};

